import './App.css';
import React, {Component} from 'react';
import ResultTable2 from './components/ResultTable2';
import {BrowserRouter as Router, Route} from 'react-router-dom'
import {MakeHttpReq} from "./components/MakeHttpReq";
// import {Controlled as CodeMirror} from 'react-codemirror2'
import {UnControlled as CodeMirror} from 'react-codemirror2'

require('codemirror/mode/sparql/sparql');
require('codemirror/mode/javascript/javascript');


class App extends Component {
    state = {
        query: ' prefix rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> \n prefix owl: <http://www.w3.org/2002/07/owl#> \n prefix xsd: <http://www.w3.org/2001/XMLSchema#> \n prefix dc: <http://purl.org/dc/terms/> \n prefix foaf: <http://xmlns.com/foaf/0.1/> \n prefix schema: <http://schema.org/> \n prefix edm: <http://www.europeana.eu/schemas/edm/> \n SELECT ?subject ?predicate ?object\n WHERE {\n ?subject ?predicate ?object \n } LIMIT 25',
        external_services: [],
        http_result: [],
        triples: '',
        clear_inputs: false,
        btn: false,
        input_value: '',
        posted: false
    };

    clearQuery = () => {
        this.setState({
            query: '',
            triples: '',
            btn: false,
            input_value: '',
            clear_inputs: true
        });
    };

    postQuery = async () => {

        // this.setState({
        //   clear_inputs: true
        // });
        MakeHttpReq('sparql', this.state.query).then(async (res) => {
                await this.setState({
                    http_result: (res && res.data && res.data.results.bindings) || [],
                    posted: true
                })
            }
        );

    };

    onChange = (v) => {
        this.setState({
            query: v.target.value,
        });
    };


    render() {
        return (
            <Router>
                <div className="App">
                    <div className="App-header">
                        <h2>Greek Children’s Art Museum Dataset</h2>
                        <h3>SPARQL Query Editor</h3>
                    </div>
                    <div className="container-fluid">
                        <div className="container-fluid">

                            <div className={'text-left mt-2'}>
                                <CodeMirror
                                    value={this.state.query}
                                    options={{
                                        mode: 'application/sparql-query',
                                        theme: 'material',
                                        lineNumbers: true
                                    }}
                                    onChange={(editor, data, value) => {
                                        // this.setState({query: value})
                                        this.state.query = value
                                    }}
                                />

                            </div>

                        </div>

                        <div className="row mb-2">

                            <button className={'btn btn-primary btn-lg btn-block col-sm-6'} onClick={this.postQuery}
                                    style={{marginTop: '0.5rem'}}>Post Query
                            </button>

                            <button className={'btn btn-warning btn-lg btn-block col-sm-6'} onClick={this.clearQuery}> Clear
                                Query
                            </button>

                        </div>
                        <Route exact path="/" render={props => (
                            <React.Fragment>
                                <ResultTable2 http_result={this.state.http_result} triples={this.state.triples}
                                              posted={this.state.posted}/>
                            </React.Fragment>
                        )}/>
                    </div>


                </div>
            </Router>

        );
    }
}

export default App;
